import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { UmSummaryService } from 'src/app/services/um/um-summary.service';
import { genderOptionsConstant } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { Users } from 'src/app/models/um/organization';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { Department } from 'src/app/models/common';
import { serviceConstants } from 'src/app/constants/service.constants';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import * as $ from 'jquery';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { UmUserMapUserViewModalComponent } from '../um-user-map-user-view-modal/um-user-map-user-view-modal.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbOffcanvasBackdrop } from '@ng-bootstrap/ng-bootstrap/offcanvas/offcanvas-backdrop';


@Component({
  selector: 'app-um-user-view-modal',
  templateUrl: './um-user-view-modal.component.html',
  styleUrls: ['./um-user-view-modal.component.scss']
})
export class UmUserViewModalComponent implements OnInit {

  formFields: any;
  operations: any;
  isView = false;
  viewId = null;
  genderOptions = genderOptionsConstant;
  isautocode: boolean = false;
  MappedUserRoles: any[] = [];
  tooltipValue: any;
  orgAuthTypeList:any[] = [];
  userForm = new UntypedFormGroup({
    ID: new UntypedFormControl(null),
    TITLE: new UntypedFormControl(null),
    EMAIL: new UntypedFormControl(null),
    Status: new UntypedFormControl(true),
    PHONE: new UntypedFormControl(null),
    ROLEID: new UntypedFormControl(null),
    DEPARTMENT_ID: new UntypedFormControl([]),
    AUTH_ID:new UntypedFormControl('0')
  })
  @Input() public Content: any;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  user: Users;
  fullname: string;
  departments: Department[] = [];
  lookups: any;
  users: any;

  constructor(
    private summaryService: UmSummaryService,
    private deptService: AdministrationSummaryService,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private commonservice: CommonService,
    private userService: UserService
  ) {

  }

  ngOnInit() {
    this.user = new Users();
    this.GetAuthenticationsByOrgId();
    if (this.Content.content && this.Content.content.id) { // Edit mode
       ;
      this.summaryService.getUser(this.Content.content.id).subscribe((result) => {
         ;
        this.userForm.patchValue({
          ID: (result.ID),
          EMAIL: (result.EMAIL),
          TITLE: (result.TITLE),
          PHONE: (result.PHONE),
          DEPARTMENT_ID: [],
          ROLEID: "",
          Status: result.Status,
          AUTH_ID:result.AUTH_ID
        })
        if (result.DEPARTMENT_ID != null && result.DEPARTMENT_ID != undefined && result.DEPARTMENT_ID != "") {
          let dept = result.DEPARTMENT_ID.split(",");
          this.userForm.controls["DEPARTMENT_ID"].setValue(dept);
        }
        this.getDepartments(result.ID);
        this.getUserMappedRoles(result.ID);
        if (this.Content.heading === 'View') {
          setTimeout(() => {
            this.userForm.disable({ emitEvent: false });
          }, 100);
        }
        else if (this.Content.heading === 'Edit') {
          this.userForm.controls["EMAIL"].disable();
        }

        if(this.Content.heading === 'Edit' || this.Content.heading === 'View'){
          if(this.Content.content.IsAnalyticsConfig == true && this.Content.content.IsOrgaccinLogi == true && result.IS_USER_LINKED_WITH_LOGI == false){
            this.commonservice.ValidationBanner("User " + result.TITLE + " details saved successfully but the analytics account is not created has failed. Please refresh the details to create an account");
          }
        }
      });
    }
    else {
      this.getDepartments("1");
    }
  }

  private getForm(): Users {
    const formModel = this.userForm.getRawValue();
    formModel.TITLE=formModel.TITLE==null?null:formModel.TITLE==undefined?undefined:formModel.TITLE.trim();
    formModel.EMAIL=formModel.EMAIL==null?null:formModel.EMAIL==undefined?undefined:formModel.EMAIL.trim();
    let Role_Id = this.MappedUserRoles.map((x) => { return x.ID });
    formModel.ROLEID = Role_Id.join(",");
    if (formModel.DEPARTMENT_ID != "" && formModel.DEPARTMENT_ID != null && formModel.DEPARTMENT_ID != undefined) {
      formModel.DEPARTMENT_ID = formModel.DEPARTMENT_ID.join(",");
    }
    else {
      formModel.DEPARTMENT_ID = "";
    }
    let user = new Users();
    user = {
      ID: formModel.ID || '',
      CODE: '',
      USER_TYPE: '',
      EMAIL: formModel.EMAIL.trim() || '',
      TITLE: formModel.TITLE.trim() || '',
      FIRST_NAME: '',
      MIDDLE_NAME: '',
      LAST_NAME: '',
      SSN: '',
      GENDER: '',
      DESIGNATION: '',
      PHONE: formModel.PHONE || '',
      PHONE_EXT: 0,
      ALTERNATIVE_PHONE: '',
      ALTERNATIVE_PHONE_EXT: 0,
      DEPARTMENT_ID: formModel.DEPARTMENT_ID || '',
      REPORT_TO_ID: '',
      PASSWORD: '',
      EXTERNAL_USER_ORGANIZATION: '',
      DEFAULT_ID: '',
      DEFAULT_DEPARTMENT_ID: '',
      AUTHTYPE: '',
      isChecked: false,
      Status: formModel.Status,
      IsAdmin: false,
      ROLEID: formModel.ROLEID || '',
      ORGANIZATION_ID: "",
      CreatedUserType: '',
      AUTH_ID:formModel.AUTH_ID
    };

    return user;
  }

  save() {
    if (this.validateControls()) {
      if (!this.Content.content && this.Content.heading === 'Add') {
        this.summaryService.addUserSummary(this.getForm()).subscribe(result => {
          if (result.Status === 0) {
            this.commonservice.SuccessBanner(result.Message);

            if (result.ErrorCode == "MAILEXCEPTION") {
              setTimeout(() => {
                this.commonservice.ValidationBanner("Unable to send email to users. Please try again");
              }, 2000);
            }
            this.modalRef.close();
          }
          else {
            this.commonservice.ValidationBanner(result.Message);
          }
        });

      } else if (this.Content.content && this.Content.content.id && this.Content.heading === 'Edit') {
        this.summaryService.editUserSummary(this.getForm()).subscribe(result => {
          if (result.Status === 0) {
            this.commonservice.SuccessBanner(result.Message);

            this.modalRef.close();
          }
          else {
            this.commonservice.ValidationBanner(result.Message);
          }
        })
       // alert("hii")

      }
    }
  }

  getDepartments(userid): void {
    this.deptService.getDepartmentsMaster('api/appuser/getactivedept/' + userid).subscribe(summary => {
      this.departments = summary;
      this.departments.forEach((item: any) => {
        if (item.IsActive == false) {
          item["icon"] = "ieg_inactive_record";
        }
      });
    });
  }
  getUserMappedRoles(userid): void {
    let Id = this.Content.content.ID;
    this.deptService.getMappedRoles('api/appuser/getur/' + userid).subscribe(summary => {
      this.MappedUserRoles = summary["roles"];
    });
  }

  
  changeVal($event) {
    setTimeout(() => {
    let selectedDept= this.userForm.controls["DEPARTMENT_ID"].value;
    if(selectedDept != "" && selectedDept != undefined && selectedDept != null)
      {
        let deptLabel=this.departments.filter((item:any)=>{
          return  selectedDept.indexOf(item.value)>-1;
         })
         let labellist=[];
         deptLabel.forEach((item: any)=>{
           labellist.push(item.label);
         });
         this.tooltipValue =labellist.join(",");
      }
      else
      {
        this.tooltipValue = "";
      }
      
    }, 200);
  } 

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.userForm.getRawValue();


    if (formData.TITLE === null || formData.TITLE === ""|| formData.TITLE === undefined) {
      $("#TITLE").addClass("ng-touched ng-invalid validate-error");
      $("#TITLE").removeClass("ng-untouched ng-valid");
      message += "Please enter Username <br/>";
      isValid = false;
    }else if((formData.TITLE != null&&formData.TITLE != undefined)&&(formData.TITLE.trim()==="")){
      $("#TITLE").addClass("ng-touched ng-invalid validate-error");
      $("#TITLE").removeClass("ng-untouched ng-valid");
      message += "Please enter Username <br/>";
      isValid = false;
    }
     else {
      $("#TITLE").addClass("ng-untouched ng-valid");
      $("#TITLE").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.EMAIL === null || formData.EMAIL === "" || formData.EMAIL === undefined) {
      $("#EMAIL").addClass("ng-touched ng-invalid validate-error");
      $("#EMAIL").removeClass("ng-untouched ng-valid");
      message += "Please enter Email ID <br/>";
      isValid = false;
    }else if((formData.EMAIL != null&&formData.EMAIL != undefined)&&(formData.EMAIL.trim()==="")){
      $("#TITLE").addClass("ng-touched ng-invalid validate-error");
      $("#TITLE").removeClass("ng-untouched ng-valid");
      message += "Please enter Email ID <br/>";
      isValid = false;
    }
     else {

      let isValidEmail = this.commonservice.validateEmail(formData.EMAIL.trim())
      if (isValidEmail) {
        $("#EMAIL").addClass("ng-untouched ng-valid");
        $("#EMAIL").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#EMAIL").addClass("ng-touched ng-invalid validate-error");
        $("#EMAIL").removeClass("ng-untouched ng-valid");
        message += "Please enter valid Email ID <br/>";
        isValid = false;
      }
    }

    if (this.MappedUserRoles !== null && this.MappedUserRoles != undefined && this.MappedUserRoles.length == 0) {
      message += "Please select atleast one User Role <br/>";
      isValid = false;
    }
    if (!isValid)
      this.commonservice.ValidationBanner(message);
    return isValid;
  }

  MapUserRoles() {
    let selectedIds = [];
    if (this.MappedUserRoles.length > 0) {
      selectedIds = this.MappedUserRoles.map(function (a) {
        return a.ID;
      });
    }
    let modalRef = this.modalService.open(UmUserMapUserViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md modal-dialog-center',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Edit',
      content: { selectedIds: selectedIds }
    };
    modalRef.result.then((result) => {
      result.forEach((element) => {
        this.MappedUserRoles.push(element);
      });
    });

  }
  DeleteMappedRoles(role) {
    let index = this.MappedUserRoles.indexOf(role);
    this.MappedUserRoles.splice(index, 1);
  }

  GetAuthenticationsByOrgId(){
    this.deptService.getConfiguration('api/configuration/GetAuthenticationsByOrgId?orgId='+this.userService.getOrganizationId()).subscribe((res)=>{
      this.orgAuthTypeList = [];
      res.forEach(x=>{
        this.orgAuthTypeList.push({"value":x.AUTH_ID,"label":x.AUTH_NAME})
      })
    })
  }
}
